import { api } from './api'

/*
 * НЦИП — реестр инвестиционных проектов, клиент `sc_atyrau_backend`.
 *
 * Ручки те же, что зовёт домен «Предпринимательство» витрины
 * (`ScDomainBusiness.vue`): сводка, справочники, список проектов, карточка.
 *
 * ЗДЕСЬ ЕСТЬ НАСТОЯЩИЕ ДАННЫЕ, в отличие от ЕРАП и ЕДДС: 141 проект области,
 * стоимость 18 750 406 млн ₸, 16 934 постоянных рабочих места, разрезы по
 * отраслям (18), районам (8), стадиям и типам. Проверено 22.09.2026.
 */

export type NcipBreakdown = {
  value: string
  count: number
  costMlnKzt: number
}

export type NcipSummary = {
  projects: number
  costMlnKzt: number
  requiredInvestmentMlnKzt: number
  domesticFundsMlnKzt: number
  foreignFundsMlnKzt: number
  jobsPermanent: number
  jobsTemporary: number
  /** Проектов со статусом реализации «С проблемами». */
  withProblems: number
  byActivity: NcipBreakdown[]
  byIndustry: NcipBreakdown[]
  byDistrict: NcipBreakdown[]
  byProjectType: NcipBreakdown[]
  byPool: NcipBreakdown[]
  byInvestorCountry: NcipBreakdown[]
  /** В реализации / В эксплуатации / С проблемами — это и есть «ход реализации». */
  byRealizationStatus: NcipBreakdown[]
}

export type NcipProject = {
  id: number
  name: string
  industry?: string | null
  district?: string | null
  address?: string | null
  sezName?: string | null
  costMlnKzt?: number | null
  requiredInvestmentMlnKzt?: number | null
  status?: string | null
  pool?: string | null
  activity?: string | null
  realizationStatus?: string | null
  projectType?: string | null
  startDate?: string | null
  commissioningDate?: string | null
  jobsPermanent?: number | null
  jobsTemporary?: number | null
  investorName?: string | null
  investorBin?: string | null
  investorIsIndividual?: boolean | null
  investorCountry?: string | null
  registeredOn?: string | null
}

export type NcipProjectsPage = {
  items?: NcipProject[]
  data?: NcipProject[]
  meta: { total: number; page: number; limit: number; pages: number }
}

/**
 * `district` — значение района РОВНО как в реестре (`/ncip/dictionaries` →
 * `districts[].value`: «Атырау», «Кзылкогинский район»), а не наше имя: сервер
 * сравнивает строку точно. Так фильтрует и домен сайта (`ScDomainBusiness.vue`).
 */
export function fetchNcipSummary(params: { district?: string } = {}): Promise<NcipSummary> {
  return api.get<NcipSummary>('/ncip/summary', { params: { district: params.district } })
}

/*
 * ПОТОЛОК СТРАНИЦЫ ВАЖНЕЕ, ЧЕМ КАЖЕТСЯ. Реестр небольшой — 141 проект, — но
 * просить их одной страницей нельзя вслепую: `limit` у бэкенда ограничен
 * сверху, и запрос с неподъёмным значением он отвергнет целиком, а не обрежет.
 * 200 — безопасный предел, покрывающий весь текущий реестр одним запросом.
 */
export function fetchNcipProjects(
  params: { limit?: number; district?: string; sort?: string } = {},
): Promise<NcipProjectsPage> {
  return api.get<NcipProjectsPage>('/ncip/projects', {
    params: { limit: params.limit ?? 200, district: params.district, sort: params.sort },
  })
}

export type NcipDictionaries = {
  districts?: NcipBreakdown[]
  [key: string]: unknown
}

export function fetchNcipDictionaries(): Promise<NcipDictionaries> {
  return api.get<NcipDictionaries>('/ncip/dictionaries')
}
